import { useLayoutEffect, useState } from 'react';

import { useLocalStorage } from '@mint-lib/hooks';
import { useTranslation } from '@mint-lib/i18n';
import { Button } from '@mint-lib/tw-components';
import { Alert } from '@mint-lib/tw-components/patterns';

import { useTotalFilesToArchiveCount } from '../../queries/index.js';
import { AutoImportInfoDialog } from '../organisms/AutoImportInfoDialog/index.js';

export const ImportsInfoAlert = () => {
  const { t } = useTranslation('@myn/import-hub');

  const {
    data: totalImportsToArchive = 0,
    isLoading: isTotalImportsToArchiveLoading,
  } = useTotalFilesToArchiveCount();

  const [isArchivingAlertClosed, setIsArchivingAlertClosed] = useLocalStorage(
    '@myn/import-hub.isArchivingAlertClosed',
    { initialValue: false },
  );
  const [isAutoImportAlertClosed, setIsAutoImportAlertClosed] = useLocalStorage(
    '@myn/import-hub.isAutoImportAlertClosed',
    { initialValue: false },
  );
  const [isAutoImportDialogOpen, setIsAutoImportDialogOpen] = useState(false);

  const isArchivingAlertOpen =
    !isArchivingAlertClosed &&
    !isTotalImportsToArchiveLoading &&
    totalImportsToArchive > 0;

  useLayoutEffect(() => {
    if (isArchivingAlertOpen && !isAutoImportAlertClosed) {
      setIsAutoImportAlertClosed(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isArchivingAlertOpen]);

  if (isTotalImportsToArchiveLoading) {
    return null;
  }

  if (isArchivingAlertOpen) {
    return (
      <Alert
        title={t('Some files are going to be archived.')}
        description={t(
          'You have a limited amount of time to review or complete your imports.',
        )}
        variant="inline"
        severity="warning"
        removable
        onClose={() => setIsArchivingAlertClosed(true)}
        className="mb-6"
      />
    );
  }

  if (!isAutoImportAlertClosed) {
    return (
      <>
        <Alert
          title={t('Automate your imports effortlessly!')}
          description={t('Click on "Learn more" for a step-by-step guide')}
          variant="inline"
          severity="info"
          removable
          onClose={() => setIsAutoImportAlertClosed(true)}
          className="mb-6"
        >
          <Button
            onClick={() => setIsAutoImportDialogOpen(true)}
            variant="outlined"
            size="small"
            data-dd-action-name="Learn more"
          >
            {t('Learn more')}
          </Button>
        </Alert>
        {isAutoImportDialogOpen && (
          <AutoImportInfoDialog
            onClose={() => setIsAutoImportDialogOpen(false)}
          />
        )}
      </>
    );
  }
};
